import React from 'react'
import { TextField } from "@mui/material";

export default function Input(props) {

    const { name, label, value,error=null, onChange, minWidth, sx=null, ...other } = props;
    return (
        <TextField
            variant="outlined"
            label={label}
            name={name}
            value={value}
            onChange={onChange}
            sx={sx}
            {...other}
            {...(error && {error:true,helperText:error})}
        />
    )
}